<template>
  <v-row
    id="list-filter-position"
    class="d-none"
    :style="'height: 1px;'"
  >
    <v-col>
      <!-- placeholder for filters for mobile -->
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'MobileFiltersPlaceholder',

  created () {
    this.setFiltersOffsetTop()
    window.addEventListener('scroll', this.scrollHandler)
    window.addEventListener('click', this.scrollHandler)
  },

  destroyed () {
    window.removeEventListener('scroll', this.scrollHandler)
    window.removeEventListener('click', this.scrollHandler)
  },

  methods: {
    scrollHandler () {
      this.setFiltersOffsetTop()
    },

    setFiltersOffsetTop () {
      const el = document.getElementById('list-filter-position')
      if (!el) { return }
      this.$set(this.$store.state, 'filtersOffsetTop', el.offsetTop)
    },
  },
}
</script>
